import { Component, OnInit, Inject,  AfterViewInit, ViewEncapsulation, ChangeDetectorRef, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { Provider, Type } from '../location-preview/location-preview.interface';
import { UntypedFormGroup } from '@angular/forms';
import { ContactFields } from '../contact-info/contact-info.interface';

@Component({
  selector: 'app-preview-address-form',
  templateUrl: './preview-address-form.component.html',
  styleUrls: ['./preview-address-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PreviewAddressFormComponent implements OnInit, AfterViewInit {
  @Input() formGroup?: UntypedFormGroup;
  @Input() formGroupName?: string;
  @Input() optionalAddress: boolean = false;
  @Input() currentValue?: any;
  @Input() isComponent?: boolean = false;



  showFields: boolean = false;
  showPreview: boolean = true;
  // optionalAddress: boolean = false;
  // currentValue: any;
  // formGroup: UntypedFormGroup;
  activeGeoCords: number[] = [];
  allowMultipleEmails: boolean = false;
  mapOptions: any = {
    module:'',
    moduleUid:'',
    coords: [],
    extraClass: '',
    width: 400,//send without units
    height: 400,
    zoom: 15,
    provider: Provider.GOOGLE,
    type: Type.IMAGE
  };
  addressFields: ContactFields = {
    contactFirstName: true,
    contactLastName: true,
    contactEmail: true,
    contactPhone: true,
    street: true,
    enableMapsAutoComplete: true,
    canTruncate: true,
    landmark: true,
    city: true,
    state: true,
    country: false,
    zipcode: true,
    latitude: false,
    longitude: false,
    enablePickFromMap: false
  };

  constructor(
    public matDialogRef: MatDialogRef<PreviewAddressFormComponent>,
    private utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetectorRef: ChangeDetectorRef
  ) { }


  closeModal(): void{
    this.matDialogRef.close();
  }

  saveAddress(): void {
    const result = this.formGroup.get(this.data?.data?.formGroupName) as UntypedFormGroup;
    result.markAllAsTouched();
    if(result.status === 'VALID'){
      if(this.activeGeoCords?.length > 0){
        const latitude = this.activeGeoCords[0];
        const longitude = this.activeGeoCords[1];
        result.get('latitude').setValue(latitude);
        result.get('longitude').setValue(longitude);
      }else{
        result.get('latitude').setValue(null);
        result.get('longitude').setValue(null);
      }
      if(!result.get('zipcode').value){
        result.get('zipcode').setValue('');
      }
      this.matDialogRef.close(result.value);
    }
  }

  getFormGroupAction(): void{
    this.formGroup.valueChanges.subscribe(
      (res: any) => {
        const formGroupName = !this.isComponent ? this.data?.data?.formGroupName: this.formGroupName;
        if(res?.[formGroupName]?.latitude !== this.currentValue?.latitude){
          this.activeGeoCords = [];
          this.currentValue.street = '';
          if(res?.[formGroupName]?.latitude && res?.[formGroupName]?.longitude){
            this.activeGeoCords = [res?.[formGroupName]?.latitude, res?.[formGroupName]?.longitude];
            this.mapOptions.coords = this.activeGeoCords;
            setTimeout(()=>{
              this.currentValue.latitude = res?.[formGroupName]?.latitude;
            });
          }
        }
      }
    );
  }

  addressChanged(result: any): void {
    const formGroupName = !this.isComponent ? this.data?.data?.formGroupName: this.formGroupName;
    this.currentValue = result;
    this.formGroup.controls[formGroupName].get('street').setValue(result?.street || '');
    this.formGroup.controls[formGroupName].get('city').setValue(result?.city || '');
    this.formGroup.controls[formGroupName].get('landmark').setValue(result?.landmark || '');
    this.formGroup.controls[formGroupName].get('state').setValue(result?.state || '');
    this.formGroup.controls[formGroupName].get('country').setValue(result?.country?.label || '');
    this.formGroup.controls[formGroupName].get('zipcode').setValue((result?.zip_code ?? result?.zipcode) || '');
    if(result?.geoLocation?.latitude && result?.geoLocation?.longitude){
      this.formGroup.controls[formGroupName].get('latitude').setValue(result?.geoLocation?.latitude || '');
      this.formGroup.controls[formGroupName].get('longitude').setValue(result?.geoLocation?.longitude || '');
      this.activeGeoCords = [result?.geoLocation?.latitude, result?.geoLocation?.longitude];
    }
  }

  ngAfterViewInit(): void {
    this.showFields = true;
    this.getFormGroupAction();
  }

  ngOnInit(): void {
    this.allowMultipleEmails = this.data?.data?.allowMultipleEmails ?? this.allowMultipleEmails;
    if(!this.isComponent){
    this.formGroup = this.data?.data?.formGroup;
    this.currentValue = this.data?.data?.value;
    this.optionalAddress = this.data?.data?.optionalAddress;
    }
    if(this.currentValue?.latitude && this.currentValue?.longitude){
      this.activeGeoCords = [this.currentValue?.latitude, this.currentValue?.longitude];
      this.mapOptions.coords = this.activeGeoCords;
    }

    if(this.data?.data?.module === 'createRoute' || this.isComponent){
      this.addressFields.contactFirstName = false;
      this.addressFields.contactLastName = false;
      this.addressFields.contactPhone = false;
      this.addressFields.contactEmail = false;
      // this.mapOptions.height = 100;
      // this.mapOptions.weight = 100;
    }

  }

}
